import { Ref } from '@vue/composition-api';
import { VueConstructor } from 'vue';
import { useAsyncModal } from '@front-app/hooks/useAsyncModal';

export interface UseDiscussionModal {
	isDiscussionModalVisible: Ref<boolean>;
	discussionModalView: Ref<null | VueConstructor>;
	loadDiscussionModal(): Promise<void>;
	showDiscussionModal(): void;
	closeDiscussionModal(): void;
}

const discussionViewLoader = () => import(/* webpackChunkName: "discussionModal" */ '@front-app/components/discussion/DiscussionModal.vue')
	.then((_) => _.default as VueConstructor);

export const useDiscussionModal = (buttonId: string): UseDiscussionModal => {
	const inner = useAsyncModal(
		buttonId,
		discussionViewLoader,
	);
	return {
		isDiscussionModalVisible: inner.isModalVisible,
		discussionModalView: inner.modalView,
		loadDiscussionModal: inner.loadModalView,
		showDiscussionModal: inner.showModal,
		closeDiscussionModal: inner.closeModal,
	};
};
